export default __webpack_public_path__ + "static/media/socialtraffic.103d6e08.jpg";